if (!customElements.get("brand-gallery")) {
  const instances = new Set();
  let framePending = false;
  let listenersActive = false;

  function scheduleUpdate() {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(() => {
      framePending = false;
      instances.forEach((i) => i._updateParallax());
    });
  }

  function onScroll() {
    scheduleUpdate();
  }

  function onResize() {
    instances.forEach((i) => {
      i._viewportH = window.innerHeight || 0;
    });
    scheduleUpdate();
  }

  function bindListeners() {
    if (listenersActive) return;
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    listenersActive = true;
  }

  function unbindListeners() {
    if (!listenersActive) return;
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onResize);
    listenersActive = false;
  }

  class BrandGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.parallaxInit) return;
      this.dataset.parallaxInit = "true";

      this._updateParallax = this._updateParallax.bind(this);
      this._viewportH = window.innerHeight || 0;
      this._motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      this._onMotionChange = () => this._init();
      this._motionQuery.addEventListener("change", this._onMotionChange);

      this._observer = new MutationObserver(() => this._init());
      this._observer.observe(this, { childList: true, subtree: true });

      this._init();
    }

    disconnectedCallback() {
      this._teardown();
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._motionQuery) {
        this._motionQuery.removeEventListener("change", this._onMotionChange);
        this._motionQuery = null;
      }
      delete this.dataset.parallaxInit;
    }

    _init() {
      if (this._motionQuery?.matches) {
        this._teardown();
        return;
      }

      this._items = Array.from(
        this.querySelectorAll("[data-parallax-speed]"),
      );
      if (!this._items.length) {
        this._teardown();
        return;
      }

      if (!this._active) {
        this._active = true;
        instances.add(this);
        bindListeners();
      }
      this._updateParallax();
    }

    _teardown() {
      if (!this._active) return;
      instances.delete(this);
      if (!instances.size) unbindListeners();
      if (this._items) {
        this._items.forEach((el) => (el.style.transform = ""));
      }
      this._active = false;
    }

    _updateParallax() {
      if (!this._active || !this._items) return;
      const rect = this.getBoundingClientRect();
      const raw = this._viewportH - rect.top;
      const max = this._viewportH + rect.height;
      const offset = Math.max(-max, Math.min(raw, max));

      this._items.forEach((el) => {
        const speed = Number(el.dataset.parallaxSpeed) || 0;
        el.style.transform = `translateY(${offset * speed}px)`;
      });
    }
  }

  customElements.define("brand-gallery", BrandGallery);
}
